import {registerReactPartial} from '@github-ui/react-core/register-partial'
import {MarketingGlobalBanner} from './MarketingGlobalBanner'

registerReactPartial('marketing-global-banner', {
  Component: MarketingGlobalBanner,
})
